module.exports = __webpack_public_path__ + "static/media/m2.9d167ce36e9fc70afcfc83cef8f6a910.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/m2.png
// module id = 5006
// module chunks = 1